var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83336 4.25H31.1667C32.7315 4.25 34 5.51856 34 7.08336V26.9167C34 28.4815 32.7315 29.75 31.1666 29.75H2.83336C1.26856 29.75 0 28.4815 0 26.9166V7.08336C0 5.51856 1.26856 4.25 2.83336 4.25Z",
    fill: "#CCF2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 9.91663H0V15.5833H34V9.91663Z",
    fill: "url(#paint0_linear_118_146)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7499 19.8334H19.8333V22.6667H29.7499V19.8334Z",
    fill: "#67D9FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.4166H4.25V25.5H17V18.4166Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_146",
    x1: 7.08347,
    y1: 22.668,
    x2: 26.9168,
    y2: 2.83473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D9F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon01);
export default __webpack_public_path__ + "static/media/choose_icon01.f80d1c22f7daa3589baa5b2e0b308a74.svg";
export { ForwardRef as ReactComponent };